import { render, staticRenderFns } from "./ExtendOtherNutrientsVitaminB12.vue?vue&type=template&id=5e95dd62&scoped=true"
import script from "./ExtendOtherNutrientsVitaminB12.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsVitaminB12.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsVitaminB12.vue?vue&type=style&index=0&id=5e95dd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e95dd62",
  null
  
)

export default component.exports